import React from "react";
import PropTypes from "prop-types";

import { K_COLORS_DARK_NAVY } from "constants.js";
import globalStyles from "globalStyles";
import { LogoIcon } from "assets/images";
import Section from "components/Section";
import Loader from "components/Loader";

const generateGreetings = () => {
  const date = new Date();
  const hour = date.getHours();
  if (hour < 12) {
    return "Good Morning";
  } else if (hour < 18) {
    return "Good Afternoon";
  } else {
    return "Good Evening";
  }
};

const LoadingScreen = (props) => {
  const { style } = props;

  return (
    <Section style={{ ...styles.section, ...style }}>
      <LogoIcon size={150} />
      <Loader />
      <h1 style={styles.greeting}>{generateGreetings()}</h1>
    </Section>
  );
};

const styles = {
  section: {
    ...globalStyles.section,
    ...globalStyles.fullHeightSection,
    textAlign: "center",
    backgroundColor: K_COLORS_DARK_NAVY,
  },
  greeting: {
    ...globalStyles.textTitleSize,
    ...globalStyles.textLightGreyColor,
  },
};

LoadingScreen.propTypes = {
  style: PropTypes.shape().isRequired,
};

export default LoadingScreen;
